import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Auth } from "aws-amplify";
import { Col } from "reactstrap";
import { compose } from "redux";
import _ from "lodash";

import HalfLemon from "assets/images/halfLemon.png";
import fullLemon from "assets/images/fullLemon.png";
import useWindowSize from "components/shared/WindowResize";
import * as gameAction from "redux/game/action";
import * as loaderAction from "redux/loader/action";

const cardData = [
  {
    id: 0,
    textbold: "Squeeze",
    text: ": 3-5 minutes",
    img: HalfLemon
  },
  {
    id: 1,
    textbold: "Slice",
    text: ": 15-30 mins",
    img: fullLemon
  }
];

const ActivityType = ({ pick_activity, ...props }) => {
  const { width } = useWindowSize();
  const categories = _.get(pick_activity, "categories", []);
  const label = _.get(pick_activity, "label", "Pick an Activity For Me");
  const picks = _.get(pick_activity, "picks", []);
  const step_1 = _.get(
    pick_activity,
    "step_1",
    "Step 1 - Select Activity Type"
  );
  const step_2 = _.get(pick_activity, "step_2", "Step 2 - Select Category");
  const slicePicks = picks?.filter((pick) => pick.activity === "slice");
  const squeezePicks = picks?.filter((pick) => pick.activity === "squeeze");

  const [gameCodeName, setGameCodeName] = useState("");
  const [sliceCategory, setSliceCategory] = useState([]);
  const [categoryArray, setCategoryArray] = useState([]);
  const [squeezeCategory, setSqueezeCategory] = useState([]);
  const [activityType, setActivityType] = useState("Squeeze");
  const [categoryType, setCategoryType] = useState("Competitive");

  useEffect(() => {
    props.endGame(true);
  }, []);

  useEffect(() => {
    let squeezeArray = [];
    let sliceArray = [];
    for (let i = 0; i < categories.length; i++) {
      for (let j = 0; j < squeezePicks.length; j++) {
        categories[i].label === squeezePicks[j].category &&
          (squeezeArray = [...squeezeArray, { ...categories[i] }]);
      }
      for (let j = 0; j < slicePicks.length; j++) {
        categories[i].label === slicePicks[j].category &&
          (sliceArray = [...sliceArray, { ...categories[i] }]);
      }
    }
    setSqueezeCategory(
      squeezeArray.sort((a, b) => a.label.localeCompare(b.label))
    );
    setSliceCategory(sliceArray.sort((a, b) => a.label.localeCompare(b.label)));
  }, [
    JSON.stringify(categories),
    JSON.stringify(slicePicks),
    JSON.stringify(squeezePicks)
  ]);

  useEffect(() => {
    activityType.toLocaleLowerCase() === "squeeze"
      ? setCategoryArray(squeezeCategory)
      : setCategoryArray(sliceCategory);
  }, [activityType, sliceCategory, squeezeCategory]);

  useEffect(() => {
    const code = picks.find(
      (pick) =>
        pick.activity === activityType.toLocaleLowerCase() &&
        pick.category === categoryType
    )?.game_code;
    setGameCodeName(code);
  }, [picks, activityType, categoryType]);

  const onActivityClick = (activity) => {
    setActivityType(activity);
    setCategoryType("Competitive");
  };

  const onStartActivity = () => {
    props.setIsLoading(true);
    const game_code = gameCodeName.split(" ")[0];
    var cognitoUser = Auth.userPool.getCurrentUser();
    if (cognitoUser !== null) {
      if (width < 768) {
        props.setGameName(game_code);
        props.history.push("/launch_controller");
      } else {
        if (game_code === "GAHW") {
          localStorage.setItem("work_game", game_code);
          props.setGameName("GAH");
        } else if (game_code === "GAHF") {
          localStorage.setItem("work_game", game_code);
          props.setGameName("GAH");
        } else if (game_code === "CHPTW") {
          localStorage.setItem("work_game", game_code);
          props.setGameName("CHPT");
        } else {
          props.setGameName(game_code);
          localStorage.removeItem("work_game");
        }
        props.history.push("/lobby");
      }
    } else {
      sessionStorage.setItem("gameCode", game_code);
      props.setGameName(game_code);
      props.history.push("/signup");
    }
  };

  return (
    <Col lg={8} xl={8}>
      <div className="activity-type-wrapper">
        <p className="txt">{label}</p>
        <div className="ActivityTypeInner">
          <p className="txt">{step_1}</p>
          <div className="row m-0 flex-nowrap flex-sm-wrap">
            {cardData.map((item) => {
              return (
                <button
                  key={item.id}
                  onClick={() => onActivityClick(item.textbold)}
                  className={`activity ${
                    activityType === item.textbold && "active"
                  }`}
                >
                  <div className="cardImg">
                    <img
                      src={item.img}
                      alt="half lemon"
                      width="30"
                      className="img-fluid"
                    />
                  </div>
                  <p className="txt">
                    <span>{item.textbold}</span>
                    {item.text}
                  </p>
                </button>
              );
            })}
          </div>
          <p className="txt">{step_2}</p>
          <div className="activity-sub-tabs">
            {categoryArray &&
              categoryArray?.map((item, index) => (
                <button
                  key={index}
                  onClick={() => setCategoryType(item.label)}
                  className={`btn category-btn ${
                    categoryType === item.label && "active"
                  }`}
                >
                  {item.label}
                </button>
              ))}
          </div>
          {categories.length !== 0 && (
            <p className="short-txt">
              <span>{categoryType}</span>
              {" - " +
                categories
                  .find((item) => item.label === categoryType)
                  .description.split(" - ")[1]}
            </p>
          )}

          <button className="btn start-btn" onClick={() => onStartActivity()}>
            Step 3 - Start Activity
          </button>
        </div>
      </div>
    </Col>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    endGame: (data) => dispatch(gameAction.endGame(data)),
    setGameName: (data) => dispatch(gameAction.setGameName(data)),
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data))
  };
};

export default compose(
  withRouter,
  connect(null, mapDispatchToProps)
)(ActivityType);
